import React from 'react';
import { CopyIcon, ExternalLinkIcon } from '@rsos/assets/icons';
import { ButtonText } from '../Location/styles/common.styles';
import {
  HoveredButton as StyledHoveredButton,
  HoveredContainer,
} from './HoveredButton.styles';

const HoveredButton = ({
  isCopied,
  onClick,
  withIcon,
  absolute,
  hasExternalLink,
}) => {
  return (
    <HoveredContainer copied={isCopied} absolute={absolute}>
      <StyledHoveredButton
        onClick={onClick}
        withIcon={withIcon}
        copied={isCopied}
        data-testid="hoveredBtn"
      >
        {hasExternalLink ? (
          <>
            <ExternalLinkIcon height={12} width={12} />
            <ButtonText>VIEW</ButtonText>
          </>
        ) : (
          <>
            <CopyIcon height={12} width={12} />
            <ButtonText>{isCopied ? 'COPIED' : 'COPY'}</ButtonText>
          </>
        )}
      </StyledHoveredButton>
    </HoveredContainer>
  );
};

export default HoveredButton;
